// to open tabs in Patient
export const TabActionPatient = (data, id, sideNavKey, childActiveId) => {
    return {
        type: 'Open_Patient_Tab',
        payload: {
            data: data,
            id: id ? id : undefined,
            sideNavKey: sideNavKey,
            childActiveId: childActiveId
        },
    }
}
export const OpenNewPatientTabAction = (data) => {
    return {
        type: 'Open_New_Patient_Tab',
        payload: {
            data: data,
        },
    }
}
export const PatientRecordAction = (Data) => {
    return {
        type: 'PatientRecordAction',
        payload: Data
    }
}
